import { Navigate, useLocation } from 'react-router-dom'

/**
 * A route redirect (such as a record's bare path to its default tab) that
 * keeps the navigation's state, so the page landed on still knows the path
 * it was opened along (see usePageTrail). A plain `<Navigate>` drops it.
 */
export default function RedirectKeepingState({ to }: { to: string }) {
  const location = useLocation()
  return <Navigate to={to} replace state={location.state} />
}
